import CommunicationMode from './CommunicationMode';

export default class StaffCommunicationMode extends CommunicationMode {
  constructor({
    id,
    value = undefined,
    comment = undefined,
    mode = undefined,
    sortOrder = undefined,
  }) {
    super({
      id,
      value,
      comment,
      mode,
      sortOrder,
    });
  }

  static get apiRoute() {
    return 'staff_communication_mode_data';
  }
}
